export const numberFormatWithGst = (value, currency = 'INR', gstPercent = 18) => {
    if (value == null || isNaN(value)) return '';

    const amountWithGst = Number(value) * (1 + gstPercent / 100);
    const rounded = Math.round(amountWithGst);

    return new Intl.NumberFormat('en-IN', {
        style: currency ? 'currency' : 'decimal',
        currency: currency || undefined,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(rounded).replace('₹', '₹ ');
};